export type MapleOSProduct = {
  id: 'mapleos-26' | 'mapleos-pro-26' | 'mapleos-enterprise-26';
  name: string;
  shortName: string;
  version: string;
  tagline: string;
  description: string;
  priceCents: number;
  priceLabel: string;
  ctaLabel: string;
  includesBareMetalInstaller: boolean;
  features: string[];
  audience: string;
  bonusCredits?: number;
};

export const MAPLEOS_PRODUCTS: MapleOSProduct[] = [
  {
    id: 'mapleos-26',
    name: 'MapleOS 26',
    shortName: 'MapleOS',
    version: '26',
    tagline: 'The browser-native and desktop-ready cognitive workspace.',
    description:
      'MapleOS 26 is the core release for teams and individuals who want the web experience and desktop installer without the advanced bare-metal deployment layer.',
    priceCents: 0,
    priceLabel: 'Free',
    ctaLabel: 'Launch MapleOS',
    includesBareMetalInstaller: false,
    audience: 'Individuals exploring MapleOS in the browser or desktop app.',
    features: [
      'MapleOS 26 web access',
      'Desktop installer included',
      'Access to MapleOS apps and workspace',
      'AI trial credits included',
    ],
  },
  {
    id: 'mapleos-pro-26',
    name: 'MapleOS Pro 26',
    shortName: 'MapleOS Pro',
    version: '26',
    tagline: 'Annual pro edition for builders, operators, and advanced users.',
    description:
      'MapleOS Pro 26 adds the bare metal installer and the full annual pro entitlement for users who want a deeper installation path and a dedicated commercial edition.',
    priceCents: 19900,
    priceLabel: '$199',
    ctaLabel: 'Buy MapleOS Pro 26',
    includesBareMetalInstaller: true,
    audience: 'Independent professionals, technical operators, and advanced MapleOS users.',
    bonusCredits: 5000,
    features: [
      'Everything in MapleOS 26',
      'Bare metal installer included',
      'Annual MapleOS Pro 26 license',
      'Web and desktop installers included',
    ],
  },
  {
    id: 'mapleos-enterprise-26',
    name: 'MapleOS Enterprise 26',
    shortName: 'MapleOS Enterprise',
    version: '26',
    tagline: 'Annual enterprise edition for organizational deployment.',
    description:
      'MapleOS Enterprise 26 is the full annual enterprise release with bare metal deployment support for organizations that want a packaged MapleOS edition for internal rollout.',
    priceCents: 180000,
    priceLabel: '$1,800',
    ctaLabel: 'Buy MapleOS Enterprise 26',
    includesBareMetalInstaller: true,
    audience: 'Organizations deploying MapleOS as a managed internal platform.',
    bonusCredits: 50000,
    features: [
      'Everything in MapleOS Pro 26',
      'Bare metal installer included',
      'Annual MapleOS Enterprise 26 license',
      'Web and desktop installers included',
    ],
  },
];

export const MAPLEOS_PRODUCT_MAP = Object.fromEntries(
  MAPLEOS_PRODUCTS.map((product) => [product.id, product])
) as Record<MapleOSProduct['id'], MapleOSProduct>;

export const AI_CREDIT_PRESETS = [1000, 2500, 5000, 10000];
export const DEFAULT_LOW_CREDIT_THRESHOLD = 100;
export const DEFAULT_AUTO_TOPUP_AMOUNT_CENTS = 1000;
export const DEFAULT_TRIAL_CREDITS = 250;

export function formatUsdFromCents(amountCents: number) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amountCents / 100);
}

export function creditsFromDollars(dollars: number) {
  return Math.max(0, Math.round(dollars * 100));
}
